module.exports = __webpack_public_path__ + "img/3-7_Expert_Knowledge.3801ec6d.png";